import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { provideComponent, useDataItem } from "scrivito"
import { KpiCard } from "shared/ui/kpi-card/KpiCard"

import { UserKpiWidget } from "./UserKpiWidgetClass"

provideComponent(UserKpiWidget, () => {
  const { t } = useTranslation()
  const kpiData = useDataItem("UserKPIs")

  const donutChart = useMemo(() => {
    return {
      centerText: kpiData?.get("totalUsers") as number,
      data: [
        {
          label: t("KPIs.Users.ExternalUsers"),
          value: kpiData?.get("totalExternalUsers") as number
        },
        {
          label: t("KPIs.Users.InternalUsers"),
          value: kpiData?.get("totalInternalUsers") as number
        }
      ].filter(item => typeof item.value === "number")
    }
  }, [kpiData])

  return (
    <KpiCard.Root>
      <KpiCard.Title title={t("KPIs.Users.Users")} />
      <KpiCard.DonutChart
        data={donutChart.data}
        centerText={donutChart.centerText}
      />
    </KpiCard.Root>
  )
})
